export default function CargoDamaged({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 3"
      viewBox="0 0 64 64"
      {...props}
    >
      <path fill="#e5a87f" d="M56 54V18l-4 2-3-2 1-4-2-3 1-3H8v46z" />
      <path
        fill="#edba94"
        d="m49 18 1-4-2-3 1-3H11v26.43A16.57 16.57 0 0 0 27.57 51H56V18l-4 2zM62 12l-4 2-3-2 1-4-2-3 1-3h7z"
      />
      <path fill="#fd6930" d="M25 8v16l7-6 7 6V8z" />
      <path fill="#fd8759" d="m32 18 7 6V8H27v14.29z" />
      <path fill="#ffd268" d="M36 38h16v12H36z" />
      <path fill="#ffe17d" d="M38 43.1a4.9 4.9 0 0 0 4.9 4.9H52V38H38z" />
      <path fill="#868687" d="M2 54h60v4H2z" />
      <path fill="#9e9e9f" d="M3 54.88A2.12 2.12 0 0 0 5.12 57H62v-3H3z" />
      <path fill="#868687" d="M44 58h12v4H44zM8 58h12v4H8z" />
      <path
        fill="#9e9e9f"
        d="M9 58.24A2.76 2.76 0 0 0 11.76 61H20v-3H9zM45 58.24A2.76 2.76 0 0 0 47.76 61H56v-3H45z"
      />
      <path d="M12 48h16v2H12zM12 44h16v2H12zM52 37H36a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V38a1 1 0 0 0-1-1zm-1 12H37V39h14z" />
      <path d="M39 41h10v2H39zM39 45h6v2h-6zM47 45h2v2h-2zM62 1h-7a1 1 0 0 0-.95.68l-1 3a1 1 0 0 0 .12.88l1.75 2.63-.89 3.57a1 1 0 0 0 .41 1.07l3 2a1 1 0 0 0 1 .06l4-2A1 1 0 0 0 63 12V2a1 1 0 0 0-1-1zm-1 10.38-2.93 1.47-1.93-1.3.83-3.3a1 1 0 0 0-.14-.8l-1.73-2.6.62-1.85H61z" />
      <path d="M62 53h-5V18a1 1 0 0 0-1.45-.9l-3.48 1.75-1.93-1.3.83-3.3a1 1 0 0 0-.14-.8l-1.73-2.6.84-2.53A1 1 0 0 0 49 7H8a1 1 0 0 0-1 1v45H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3h22v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zM26 9h12v12.83l-5.35-4.59a1 1 0 0 0-1.3 0L26 21.83zM9 9h15v15a1 1 0 0 0 1.65.76L32 19.32l6.35 5.44A1 1 0 0 0 40 24V9h7.61l-.56 1.68a1 1 0 0 0 .12.87l1.75 2.64-.89 3.57a1 1 0 0 0 .41 1.07l3 2a1 1 0 0 0 1 .07L55 19.61V53H9zm10 52H9v-2h10zm36 0H45v-2h10zm6-4H3v-2h58z" />
    </svg>
  );
}
